import styled from 'styled-components'
import Typography from '@ntuctech/devex-tangram/Typography'
import { SCREEN_SIZE } from '../../../../lib/Media'
import jwcLogo from '../../../../components/icons/svg/jwc-logo.svg'

export const StyledTypography = styled(Typography)`
  margin: 0.5rem 0;
`

export const StyledJWCLogo = styled.img.attrs({
  src: jwcLogo,
})`
  transform: translateY(-0.3rem);
`

export const CustomPanel = styled.div`
  background: #fff;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1rem;
  .point {
    margin: 1.5rem 0 0.5rem;
  }
  .browse-button {
    margin: 1rem 0 0;
  }
  .browse-button-container {
    text-align: center;
  }
  ${SCREEN_SIZE.From.Desktop} {
    margin-top: 3.75rem;
    margin-bottom: 0;
    padding: 3.125rem 5rem 0;
    .title {
      font-size: 1.875rem;
      text-align: center;
      margin-bottom: 2.5rem;
    }

    .browse-button-container {
      text-align: initial;
    }
  }
`

export const StepHolder = styled.div`
  margin-top: 1rem;
  ${SCREEN_SIZE.From.Desktop} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`

export const Step = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  strong {
    font-weight: 600;
  }

  > *:first-child {
    margin-right: 1rem;
  }
  .content {
    flex: 1 1 auto;
  }
  a {
    text-decoration: none;
  }

  &:nth-child(even) {
    flex-direction: row-reverse;
    > *:first-child {
      margin-left: 1rem;
      margin-right: 0;
      ${SCREEN_SIZE.From.Desktop} {
        margin-right: 1rem;
        margin-left: 0;
      }
    }
  }

  .subhead {
    color: #1557bf;
    text-transform: uppercase;
  }

  em {
    font-style: italic;
  }

  ${SCREEN_SIZE.From.Desktop} {
    margin-bottom: 4.375rem;
    &:nth-child(even) {
      flex-direction: row;
    }
    flex-basis: 27%;
    img {
      height: 10rem;
      width: auto;
    }
  }
`
